import { render, staticRenderFns } from "./CustomCarousel.vue?vue&type=template&id=0e2502c0&scoped=true&"
import script from "./CustomCarousel.vue?vue&type=script&lang=ts&"
export * from "./CustomCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./CustomCarousel.vue?vue&type=style&index=0&id=0e2502c0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2502c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCarousel,VCarouselItem,VCol,VImg,VRow,VSheet})
